var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVoucherApplied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "major / ico_verified filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13745 2.49797C9.13116 1.38796 10.869 1.38796 11.8628 2.49797L12.4467 3.15028C12.6155 3.33885 12.8609 3.44048 13.1136 3.42651L13.9878 3.37818C15.4753 3.29595 16.7042 4.52482 16.622 6.01237L16.5736 6.88654C16.5597 7.13925 16.6613 7.38461 16.8499 7.55343L17.5022 8.13738C18.6122 9.13109 18.6122 10.869 17.5022 11.8627L16.8499 12.4466C16.6613 12.6155 16.5597 12.8608 16.5736 13.1135L16.622 13.9877C16.7042 15.4753 15.4753 16.7041 13.9878 16.6219L13.1136 16.5736C12.8609 16.5596 12.6155 16.6612 12.4467 16.8498L11.8628 17.5021C10.869 18.6121 9.13116 18.6121 8.13745 17.5021L7.55349 16.8498C7.38467 16.6612 7.13931 16.5596 6.8866 16.5736L6.01243 16.6219C4.52488 16.7041 3.29601 15.4753 3.37825 13.9877L3.42657 13.1135C3.44054 12.8608 3.33891 12.6155 3.15034 12.4466L2.49804 11.8627C1.38803 10.869 1.38802 9.1311 2.49803 8.13739L3.15034 7.55343C3.33891 7.38461 3.44054 7.13925 3.42657 6.88654L3.37825 6.01237C3.29601 4.52482 4.52488 3.29595 6.01243 3.37818L6.8866 3.42651C7.13931 3.44048 7.38467 3.33885 7.55349 3.15028L8.13745 2.49797ZM13.9449 8.76665C14.2407 8.47689 14.2407 8.0071 13.9449 7.71734C13.649 7.42758 13.1693 7.42758 12.8735 7.71734L9.20289 11.3124L7.08403 9.53358C6.76636 9.2669 6.2881 9.30293 6.01581 9.61406C5.74352 9.92519 5.78031 10.3936 6.09798 10.6603L9.08786 13.2343C9.15306 13.2905 9.25025 13.2877 9.31222 13.2281L13.9449 8.76665Z",
    fill: "#008E53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoucherApplied);
export default __webpack_public_path__ + "static/media/icon_voucher_applied.758ab8238d4e75e9a4fa7ab4df226833.svg";
export { ForwardRef as ReactComponent };